module.exports = __webpack_public_path__ + "static/room2-1-9049ccdc3b58ca8e1a27367f4cfe69d3.jpg";